import { CTAPopup } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import React from "react";
import { ReactComponent as ArrowRightIcon } from "./assets/arrow-right.svg";

export const EmailForwardingRequiredPopup: React.FC<{
  isOpen: boolean;
  onRequestClose: () => void;
  onOpenSettings: () => void;
}> = ({ isOpen, onRequestClose, onOpenSettings }) => {
  const { t } = useTranslations();

  return (
    <CTAPopup
      isOpen={isOpen}
      icon="⚠️"
      title={t({
        id: "client-support-page.email-is-disconnected",
        defaultMessage: "Email is disconnected",
      })}
      content={t({
        id: "client-support-page.email-forwarding-turned-off-cant-send",
        defaultMessage:
          "New emails can't be sent as email forwarding for this email address is turned off. Reconnect it to proceed with email related threads",
      })}
      buttons={[
        {
          label: (
            <span className="flex items-center justify-center gap-2">
              {t({
                id: "client-support-page.open-settings",
                defaultMessage: "Open settings",
              })}
              <ArrowRightIcon />
            </span>
          ),
          onClick: onOpenSettings,
        },
      ]}
      onClose={onRequestClose}
    />
  );
};
